 
export function spBeginCheckout({ method, items }) {
    if (!method || !Array.isArray(items)) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'sp_begin_checkout',
        method,
        ecommerce: {
            items
        }
    });
}